import { time } from "vue-app-utils-web";

const currentTime = time;

const weekdayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function minutesToClock (minutes) {
  if (minutes == null) return "";
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const suffix = hours >= 12 ? "PM" : "AM";
  const clockHour = String(((hours + 11) % 12) + 1).padStart(2, "0");
  return `${clockHour}:${String(mins).padStart(2, "0")} ${suffix}`;
}

function minutesToHHMM (minutes) {
  if (minutes == null) return "";
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
}

function clockToMinutes (clock) {
  if (!clock) return null;
  const [timeStr, modifier] = clock.split(" ");
  const [hours, minutes] = timeStr.split(":").map(Number);
  if (modifier) {
    const isPM = modifier.toUpperCase() === "PM";
    let h = hours;
    if (isPM && hours !== 12) h = hours + 12;
    if (!isPM && hours === 12) h = 0;
    return h * 60 + minutes;
  }
  return hours * 60 + minutes;
}

function dateToInputString (value) {
  if (value == null) return "";
  if (typeof value === "string") return value;
  const d = typeof value.toDate === "function" ? value.toDate() : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${month}-${day}`;
}

function format24to12 (time) {
  if (!time) return "";
  const [hours, minutes] = time.split(":").map(Number);
  const suffix = hours >= 12 ? "PM" : "AM";
  const h = ((hours + 11) % 12) + 1;
  return `${String(h).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${suffix}`;
}

export { currentTime, weekdayNames, minutesToClock, minutesToHHMM, clockToMinutes, dateToInputString, format24to12 };